module.exports = __webpack_public_path__ + "omniv2/img/icon-speedometer2-dark.fe587ceb.svg";